import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  Title,
  Tooltip,
  Chart as chartJS,
} from 'chart.js';


chartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const DoublebarChart = () => {


  const JsonData = [
    { label: "jan", value1: "12",value2: "15" },
    { label: "feb", value1: "14",value2: "22" },
    { label: "mar", value1: "20",value2: "32" },
    { label: "apr", value1: "23" ,value2: "32"},
    { label: "may", value1: "15",value2: "12" },
    { label: "june", value1: "12",value2: "40" },
    { label: "jul", value1: "8",value2: "23" },
   
  ];
 

  // Transform JSON data into chart data format
  const barChartData = {
    labels: JsonData.map(item => item.label),
    datasets: [
      
      {barPercentage: 0.7,
        categoryPercentage: 0.6,
        label:'Per Month',
        data:JsonData.map(item => item.value1),
        backgroundColor:"#0854b4",
      },
      {
        label:'Per Day',
        barPercentage: 0.7,
        categoryPercentage: 0.6,
        data:JsonData.map(item => item.value2),
        backgroundColor:"#71acf8",
      }
    ],
  };

  const options = {
    
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          display: true,
          
        },
        border: {
          display: false,
        },
        // title: {
        //     display: true,
        //     align: 'start',
        //     position: 'top',
        //     text: "Expectancy"
        //   }
       
      },
      y: {
                

       
        grid: {
          display: false,
        },
        min: 5,
      max: 25,
      ticks: {
        beginAtZero: true,
        callback: function (value) {
            return value + "%"; // Append '%' to each tick value
          },
        stepSize: 5, // Set step size to 5% intervals
      },
        border: {
          display: false,
        },

   
      },
    },
    
    plugins: {
      legend: {
        display: true, // Hide legend
        position: 'top',
      align:'end'
      },
      title: {
      display: true,
      text: "Expectancy",
      position: 'top',
      align:'start'
    },
      
    }
  };

  return (
    <div style={{paddingLeft:'20px',paddingRight:"20px"}}>
     
        <Bar options={options} data={barChartData} />
      
      
    </div>
  );
};

export default DoublebarChart;
